import ui from "./ui.module.css";

// Small uppercase label with a value underneath (detail headers).
const Field = ({ label, children }) => (
  <div>
    <div className={ui.fieldLabel}>{label}</div>
    <div className={ui.fieldValue}>{children || "—"}</div>
  </div>
);

export default Field;
